"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ThemeWatcher = exports.DEFAULT_THEME = undefined;

var _values = require("babel-runtime/core-js/object/values");

var _values2 = _interopRequireDefault(_values);

var _create = require("babel-runtime/core-js/object/create");

var _create2 = _interopRequireDefault(_create);

var _slicedToArray2 = require("babel-runtime/helpers/slicedToArray");

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require("babel-runtime/core-js/object/entries");

var _entries2 = _interopRequireDefault(_entries);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

exports.enumerateThemes = enumerateThemes;
exports.getBaseTheme = getBaseTheme;
exports.setTheme = setTheme;

var _languageHandler = require("./languageHandler");

var _Tinter = require("./Tinter");

var _Tinter2 = _interopRequireDefault(_Tinter);

var _dispatcher = require("./dispatcher");

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _SettingsStore = require("./settings/SettingsStore");

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_THEME = exports.DEFAULT_THEME = "light"; /*
                                                     Copyright 2019 Michael Telatynski <7t3chguy@gmail.com>
                                                     Copyright 2019 The Matrix.org Foundation C.I.C.
                                                     
                                                     Licensed under the Apache License, Version 2.0 (the "License");
                                                     you may not use this file except in compliance with the License.
                                                     You may obtain a copy of the License at
                                                     
                                                         http://www.apache.org/licenses/LICENSE-2.0
                                                     
                                                     Unless required by applicable law or agreed to in writing, software
                                                     distributed under the License is distributed on an "AS IS" BASIS,
                                                     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                     See the License for the specific language governing permissions and
                                                     limitations under the License.
                                                     */

var ThemeWatcher = exports.ThemeWatcher = function () {
    function ThemeWatcher() {
        var _this = this;

        (0, _classCallCheck3.default)(this, ThemeWatcher);

        this._onChange = function () {
            _this.recheck();
        };

        this._onAction = function (payload) {
            if (payload.action === 'recheck_theme') {
                // XXX forceTheme
                _this.recheck(payload.forceTheme);
            }
        };

        this._themeWatchRef = null;
        this._systemThemeWatchRef = null;
        this._dispatcherRef = null;

        // we have both here as each may either match or not match, so by having both
        // we can get the tristate of dark/light/unsupported
        this._preferDark = global.matchMedia("(prefers-color-scheme: dark)");
        this._preferLight = global.matchMedia("(prefers-color-scheme: light)");

        this._currentTheme = this.getEffectiveTheme();
    }

    (0, _createClass3.default)(ThemeWatcher, [{
        key: "start",
        value: function start() {
            this._themeWatchRef = _SettingsStore2.default.watchSetting("theme", null, this._onChange);
            this._systemThemeWatchRef = _SettingsStore2.default.watchSetting("use_system_theme", null, this._onChange);
            if (this._preferDark.addEventListener) {
                this._preferDark.addEventListener('change', this._onChange);
                this._preferLight.addEventListener('change', this._onChange);
            }
            this._dispatcherRef = _dispatcher2.default.register(this._onAction);
        }
    }, {
        key: "stop",
        value: function stop() {
            if (this._preferDark.addEventListener) {
                this._preferDark.removeEventListener('change', this._onChange);
                this._preferLight.removeEventListener('change', this._onChange);
            }
            _SettingsStore2.default.unwatchSetting(this._systemThemeWatchRef);
            _SettingsStore2.default.unwatchSetting(this._themeWatchRef);
            _dispatcher2.default.unregister(this._dispatcherRef);
        }
    }, {
        key: "recheck",


        // XXX: forceTheme param aded here as local echo appears to be unreliable
        // https://github.com/vector-im/riot-web/issues/11443
        value: function recheck(forceTheme) {
            var oldTheme = this._currentTheme;
            this._currentTheme = forceTheme === undefined ? this.getEffectiveTheme() : forceTheme;
            if (oldTheme !== this._currentTheme) {
                setTheme(this._currentTheme);
            }
        }
    }, {
        key: "getEffectiveTheme",
        value: function getEffectiveTheme() {
            // If the user has specifically enabled the system matching option (excluding default),
            // then use that over anything else. We pick the lowest possible level for the setting
            // to ensure the ordering otherwise works.
            var systemThemeExplicit = _SettingsStore2.default.getValueAt(_SettingsStore.SettingLevel.DEVICE, "use_system_theme", null, false, true);
            if (systemThemeExplicit) {
                if (this._preferDark.matches) return 'dark';
                if (this._preferLight.matches) return 'light';
            }

            // If the user has specifically enabled the theme (without the system matching option being
            // enabled specifically and excluding the default), use that theme. We pick the lowest possible
            // level for the setting to ensure the ordering otherwise works.
            var themeExplicit = _SettingsStore2.default.getValueAt(_SettingsStore.SettingLevel.DEVICE, "theme", null, false, true);
            if (themeExplicit) return themeExplicit;

            // If the user hasn't really made a preference in either direction, assume the defaults of the
            // settings and use those.
            if (_SettingsStore2.default.getValue('use_system_theme')) {
                if (this._preferDark.matches) return 'dark';
                if (this._preferLight.matches) return 'light';
            }
            return _SettingsStore2.default.getValue('theme');
        }
    }, {
        key: "isSystemThemeSupported",
        value: function isSystemThemeSupported() {
            return this._preferDark.matches || this._preferLight.matches;
        }
    }]);
    return ThemeWatcher;
}();

ThemeWatcher._instance = null;
function enumerateThemes() {
    var BUILTIN_THEMES = {
        "light": (0, _languageHandler._t)("Light theme"),
        "dark": (0, _languageHandler._t)("Dark theme")
    };
    var customThemes = _SettingsStore2.default.getValue("custom_themes");
    var customThemeNames = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(customThemes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref2 = _step.value;
            var name = _ref2.name;

            customThemeNames["custom-" + name] = name;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return (0, _assign2.default)({}, customThemeNames, BUILTIN_THEMES);
}

function setCustomThemeVars(customTheme) {
    var style = document.body.style;

    if (customTheme.colors) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = (0, _getIterator3.default)((0, _entries2.default)(customTheme.colors)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var _step2$value = (0, _slicedToArray3.default)(_step2.value, 2),
                    name = _step2$value[0],
                    hexColor = _step2$value[1];

                style.setProperty("--" + name, hexColor);
                // uses #rrggbbaa to define the color with alpha values at 0% and 50%
                style.setProperty("--" + name + "-0pct", hexColor + "00");
                style.setProperty("--" + name + "-50pct", hexColor + "7F");
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    }
}

function getCustomTheme(themeName) {
    // set css variables
    var customThemes = _SettingsStore2.default.getValue("custom_themes");
    if (!customThemes) {
        throw new Error("No custom themes set, can't set custom theme \"" + themeName + "\"");
    }
    var customTheme = customThemes.find(function (t) {
        return t.name === themeName;
    });
    if (!customTheme) {
        var knownNames = customThemes.map(function (t) {
            return t.name;
        }).join(", ");
        throw new Error("Can't find custom theme \"" + themeName + "\", only know " + knownNames);
    }
    return customTheme;
}

/**
 * Gets the underlying theme name for the given theme. This is usually the theme or
 * CSS resource that the theme relies upon to load.
 * @param {string} theme The theme name to get the base of.
 * @returns {string} The base theme (typically "light" or "dark").
 */
function getBaseTheme(theme) {
    if (!theme) return "light";
    if (theme.startsWith("custom-")) {
        var customTheme = getCustomTheme(theme.substr(7));
        return customTheme.is_dark ? "dark-custom" : "light-custom";
    }

    return theme; // it's probably a base theme
}

/**
 * Called whenever someone changes the theme
 *
 * @param {string} theme new theme
 */
function setTheme(theme) {
    if (!theme) {
        var themeWatcher = new ThemeWatcher();
        theme = themeWatcher.getEffectiveTheme();
    }
    var stylesheetName = theme;
    if (theme.startsWith("custom-")) {
        var customTheme = getCustomTheme(theme.substr(7));
        stylesheetName = customTheme.is_dark ? "dark-custom" : "light-custom";
        setCustomThemeVars(customTheme);
    }

    // look for the stylesheet elements.
    // styleElements is a map from style name to HTMLLinkElement.
    var styleElements = (0, _create2.default)(null);
    var a = void 0;
    for (var i = 0; a = document.getElementsByTagName("link")[i]; i++) {
        var href = a.getAttribute("href");
        // shouldn't we be using the 'title' tag rather than the href?
        var match = href.match(/^bundles\/.*\/theme-(.*)\.css$/);
        if (match) {
            styleElements[match[1]] = a;
        }
    }

    if (!(stylesheetName in styleElements)) {
        throw new Error("Unknown theme " + stylesheetName);
    }

    // disable all of them first, then enable the one we want. Chrome only
    // bothers to do an update on a true->false transition, so this ensures
    // that we get exactly one update, at the right time.
    //
    // ^ This comment was true when we used to use alternative stylesheets
    // for the CSS.  Nowadays we just set them all as disabled in index.html
    // and enable them as needed.  It might be cleaner to disable them all
    // at the same time to prevent loading two themes simultaneously and
    // having them interact badly... but this causes a flash of unstyled app
    // which is even uglier.  So we don't.

    styleElements[stylesheetName].disabled = false;

    var switchTheme = function switchTheme() {
        // we re-enable our theme here just in case we raced with another
        // theme set request as per https://github.com/vector-im/riot-web/issues/5601.
        // We could alternatively lock or similar to stop the race, but
        // this is probably good enough for now.
        styleElements[stylesheetName].disabled = false;
        (0, _values2.default)(styleElements).forEach(function (a) {
            if (a == styleElements[stylesheetName]) return;
            a.disabled = true;
        });
        _Tinter2.default.setTheme(theme);
    };

    // turns out that Firefox preloads the CSS for link elements with
    // the disabled attribute, but Chrome doesn't.

    var cssLoaded = false;

    styleElements[stylesheetName].onload = function () {
        switchTheme();
    };

    for (var _i = 0; _i < document.styleSheets.length; _i++) {
        var ss = document.styleSheets[_i];
        if (ss && ss.href === styleElements[stylesheetName].href) {
            cssLoaded = true;
            break;
        }
    }

    if (cssLoaded) {
        styleElements[stylesheetName].onload = undefined;
        switchTheme();
    }
}
//# sourceMappingURL=theme.js.map